import { useMutation, useQueryClient, UseMutationOptions } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export interface DeletePlaygroundSessionChatMessagesResponseI {
  success: boolean;
  deleted_count: number;
}

export interface DeletePlaygroundSessionChatMessagesParamsI {
  workspaceId: number;
  sessionId: string;
  variableSetIndex?: number;
}

export const useAPIDeletePlaygroundSessionChatMessages = (
  userToken: string,
  options?: UseMutationOptions<
    DeletePlaygroundSessionChatMessagesResponseI,
    Error,
    DeletePlaygroundSessionChatMessagesParamsI
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    DeletePlaygroundSessionChatMessagesResponseI,
    Error,
    DeletePlaygroundSessionChatMessagesParamsI
  >(
    variables => {
      const baseUrl = ENDPOINTS.playground_session_chat_messages(
        variables.workspaceId,
        variables.sessionId,
      );

      const url = new URL(baseUrl);
      url.searchParams.set("variable_set_index", String(variables.variableSetIndex));

      return fetch(url, {
        method: "DELETE",
        headers: authHeader(userToken),
      }).then(handleResponse);
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          "playground-session-chat-messages",
          variables.workspaceId,
          variables.sessionId,
        ]);
      },
      ...options,
    },
  );
};
